import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomeView from './views/HomeView';
import PresentationView from './views/PresentationView';
import ProductsView from './views/ProductsView';
import './App.css';
import { useEffect } from 'react';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomeView />} />
          <Route path="/presentation" element={<PresentationView />} />
          {/* Main categories route */}
          <Route path="/categories">
            {/* Individual product routes */}
            <Route path=":productId" element={<ProductsView />} />
            {/* Optional: Default route when no product is specified */}
            <Route index element={<ProductsView />} />
          </Route>
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;